import React from 'react';
import { motion } from 'framer-motion';
const tomi = [{
  num: '1',
  title: 'Logica di Programmazione e Pensiero Computazionale',
  desc: "Ti porta dal pensiero computazionale alla logica booleana e ai primi algoritmi. Perfetto per le classi prime e seconde del biennio. Include 5 attività unplugged pronte per l'aula."
}, {
  num: '2',
  title: 'Algoritmi e Pseudocodice',
  desc: 'Copre pseudocodice formale, strutture di controllo, algoritmi di ricerca e ordinamento con tracce di esecuzione complete e introduzione alla notazione O-grande.'
}, {
  num: '3',
  title: 'Programmazione Base con Python',
  desc: 'Guida completa a Python dalle variabili alle funzioni, dai cicli alla gestione degli errori, con un progetto finale funzionante incluso.'
}, {
  num: '4',
  title: 'Strutture Dati Semplici',
  desc: 'Liste, dizionari, set, tuple e comprensioni applicate a problemi reali, con algoritmi implementati in Python.'
}, {
  num: '5',
  title: 'Sviluppo Web Base HTML e CSS',
  desc: 'HTML5 semantico, CSS3, Flexbox e Responsive Design Mobile-First con progetto sito scolastico completo.'
}, {
  num: '6',
  title: 'Progetti Pratici Interdisciplinari',
  desc: '5 progetti pratici che integrano Python e HTML/CSS in sistemi reali completi, con connessioni a Matematica, Fisica e Italiano.'
}];
export function TomiSection() {
  return <section className="py-10 sm:py-12 px-4 bg-[#0d0d17] relative border-t border-brand-orange/10" data-id="element-236">
      <div className="max-w-5xl mx-auto" data-id="element-237">
        <div className="text-center mb-8" data-id="element-238">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl sm:text-4xl md:text-5xl font-black uppercase text-brand-cream mb-4" data-id="element-239">
            Cosa include il{' '}
            <span className="text-brand-orange" data-id="element-240">Kit Tecnico Elite?</span>
          </motion.h2>
          <p className="text-xl text-brand-gold font-bold" data-id="element-241">
            6 TOMI COMPLETI — Oltre 360 pagine di contenuto reale, pronto
            all'uso da oggi stesso.
          </p>
        </div>

        <div className="grid grid-cols-1 gap-4" data-id="element-242">
          {tomi.map((tomo, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-brand-card border border-white/10 p-6 rounded-2xl relative overflow-hidden group hover:border-brand-orange/40 transition-colors" data-id="element-243">
              <div className="absolute -right-4 -top-4 text-8xl font-black text-white/5 group-hover:text-brand-orange/10 transition-colors" data-id="element-244">
                {tomo.num}
              </div>
              <div className="relative z-10" data-id="element-245">
                <div className="inline-block bg-brand-orange text-white text-xs font-black px-3 py-1 rounded-full mb-4 uppercase tracking-wider" data-id="element-246">
                  Tomo {tomo.num}
                </div>
                <h3 className="text-xl font-bold text-brand-cream mb-3 leading-tight" data-id="element-247">
                  {tomo.title}
                </h3>
                <p className="text-gray-400 text-sm font-medium leading-relaxed" data-id="element-248">
                  {tomo.desc}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}